function initScrollToReviews() {
  setTimeout(() => {
    const trigger = document.querySelector(".product__info-wrapper .cw-tmt-rating.new-product-rating");
    const target = document.querySelector(".scroll-target-review-section");
    if (!trigger || !target) return;

    trigger.addEventListener("click", () => {
      target.scrollIntoView({ behavior: "smooth" });
    });
  }, 1000);
}

function initNewSkuGtag() {
  const productInfoRoot = document.querySelector("product-info[data-is-new-arrival]");
  const isNewArrival = productInfoRoot?.dataset?.isNewArrival === "true";
  if (!isNewArrival) return;
  if (typeof window.gtag !== "function") return;

  setTimeout(() => {
    window.gtag("event", "newsku", {
      event_category: "Product Events",
      event_label: "New SKU",
      value: 1
    });
  }, 15000);
}

function initYearSelector() {
  const yearBox = document.querySelector(".boxProductSelectYear");
  const yearInput = document.querySelector('input[name="properties[year]"]');
  const yearSelect = yearBox?.querySelector(".productYear");
  const dependentElements = document.querySelectorAll(".requires-year");

  // Exit if essential elements are not found
  if (!yearBox || !yearInput || !yearSelect) {
    return;
  }

  // Helper to get a set of valid year values from the dropdown
  const getValidYears = () =>
    new Set(
      Array.from(yearSelect.options)
        .map((option) => option.value)
        .filter(Boolean)
    );

  // Central function to update the entire state based on a year value
  function setYear(yearValue) {
    const validYears = getValidYears();
    const normalizedYear = (yearValue || "").trim();
    const isValidYear = validYears.has(normalizedYear);
    const finalYear = isValidYear ? normalizedYear : "";

    // 1. Update the input field
    if (yearInput.value !== finalYear) {
      yearInput.value = finalYear;
    }

    // 2. Update the select dropdown
    if (yearSelect.value !== finalYear) {
      yearSelect.value = finalYear;
    }

    // 3. Update the URL
    const url = new URL(window.location.href);
    if (finalYear) {
      url.searchParams.set("year", finalYear);
    } else {
      url.searchParams.delete("year");
    }
    // Only push a new state if the URL has actually changed
    if (url.href !== window.location.href) {
      window.history.replaceState({}, "", url.href);
    }

    // 4. Update the UI visibility
    const hasYear = finalYear !== "";
    yearBox.classList.toggle("hidden", hasYear);
    dependentElements.forEach((el) => el.classList.toggle("hidden", !hasYear));
  }

  // ---- Event Listener ----
  // Use a single event listener to handle changes
  if (yearSelect.dataset.yearBound !== "true") {
    yearSelect.dataset.yearBound = "true";
    yearSelect.addEventListener("change", (event) => {
      setYear(event.target.value);
      initProductTitleYear();
    });
  }

  // ---- Initialization ----
  // Initialize the state from the URL on page load
  const initialYear = new URLSearchParams(window.location.search).get("year");
  setYear(initialYear);
}

function initProductTitleYear() {
// Get year from URL
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");

  if (year) {
    // Find <h1> and <h2> inside .product__title
    const h1 = document.querySelector(".product__title > h1");
    const h2 = document.querySelector(".product__title a h2");

    // Prepend year if elements exist
    if (h1) h1.textContent = `${year} ${h1.textContent}`;
    if (h2) h2.textContent = `${year} ${h2.textContent}`;
  }
}

document.addEventListener("DOMContentLoaded", () => {
  initScrollToReviews();
  initNewSkuGtag();
  initYearSelector();
  initProductTitleYear();
});
